var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileGray600(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 8.14293C8.38091 8.14293 7.08567 6.88936 7.08567 5.35721C7.08567 3.82507 8.38091 2.5715 9.99996 2.5715C11.619 2.5715 12.9143 3.82507 12.9143 5.35721C12.9143 6.88936 11.619 8.14293 9.99996 8.14293ZM9.99996 10.0001C12.6666 10.0001 14.819 7.92007 14.819 5.35721C14.819 2.79436 12.6666 0.714355 9.99996 0.714355C7.33329 0.714355 5.18091 2.79436 5.18091 5.35721C5.18091 7.92007 7.33329 10.0001 9.99996 10.0001ZM16.6666 17.4286H3.33328V16.1936C3.33328 14.5686 5.53329 12.8879 9.99996 12.8879C14.4666 12.8879 16.6666 14.5686 16.6666 16.1936V17.4286ZM9.99996 11.0308C3.65709 11.0308 1.42852 14.1229 1.42852 16.1936V19.2858H18.5714V16.1936C18.5714 14.1229 16.3428 11.0308 9.99996 11.0308Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGray600);
export default __webpack_public_path__ + "static/media/profile_gray600.aaea1deac1eaef6788743ae959c7a39e.svg";
export { ForwardRef as ReactComponent };